/*
 * @FilePath: main.js
 * @Author: 孙新宇
 * @Date: 2022-12-27 09:15:51
 * @LastEditTime: 2023-01-02 08:46:40
 * @Descripttion: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/reset.css'
import { createPinia, PiniaVuePlugin } from 'pinia'

Vue.use(PiniaVuePlugin)
Vue.config.productionTip = false
Vue.config.silent = true // 去掉VueWarn

const pinia = createPinia()

// localStorage.clear();

new Vue({
  router,
  pinia,
  render: h => h(App)
}).$mount('#app')